import { App } from '@stuller/stullercom/feat/app'
import { config } from '@fortawesome/fontawesome-svg-core'
import '@stuller/stullercom/ui/fonts.scss'
import '@stuller/stullercom/ui/styles.scss'

// Turn off font awesome automatically adding CSS to `<head>`
config.autoAddCss = false

export default App
